
export function setCurrentPage (state, payload) {
  state.currentPage = payload
}

export function setUserCurrentLocation (state, payload) {
  state.userCurrentLocation = payload
}

export function setLoggedUser (state, payload) {
  state.loggedUser = payload
}

export function setLoggedToken (state, payload) {
  state.loggedToken = payload
}
